'use strict';

function isValidInputType(cardNumber) {
  return typeof cardNumber === 'string' || cardNumber instanceof String;
}

module.exports = isValidInputType;



//////////////////
// WEBPACK FOOTER
// ./node_modules/credit-card-type/lib/is-valid-input-type.js
// module id = 376
// module chunks = 0